export default __webpack_public_path__ + "static/media/englishIcon.33a2fe5f.svg";